import { GET_MODE } from "../actions/types";
const initialState = "dark";
export default function modeReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case GET_MODE:
      return {
        payload,
      };
    default:
      return {
        state,
      };
  }
}
